import { motion } from "framer-motion";

export const ImpactStat = () => (
  <section data-testid="impact-stat-section" className="py-24 md:py-32 lg:py-40 bg-black text-[#F5F5F7]">
    <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="text-xs md:text-sm tracking-[0.2em] uppercase font-semibold text-[#86868B] mb-8"
      >
        The Impact of a Simple Switch
      </motion.p>

      <motion.h2
        initial={{ opacity: 0, y: 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, delay: 0.1 }}
        data-testid="impact-stat-heading"
        className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.1] tracking-tight font-medium"
      >
        If <span className="font-bold">1,000 people</span> choose Nyla every day,
        we collectively save{" "}
        <span className="font-bold text-white">5 million litres</span>{" "}
        of groundwater every year — for the generations still to come.
      </motion.h2>

      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-40px" }}
        transition={{ duration: 0.8, delay: 0.25 }}
        className="mt-8 text-lg leading-relaxed text-[#86868B]"
      >
        Every bottle you choose is a well left full, a river left flowing, a promise kept to the planet.
      </motion.p>

      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-40px" }}
        transition={{ duration: 0.8, delay: 0.35 }}
        className="mt-10 text-xs md:text-sm tracking-[0.25em] uppercase font-semibold text-[#F5F5F7]/80"
      >
        Think Nyla. Drink with Purpose.
      </motion.p>
    </div>
  </section>
);
